import React from 'react'

import { Text } from '../containers/Language'

const PreFooter = () => {
  return (
    <div class="container columns prefooter">
      <p className="big">Capabilities</p>
      <div className="column text is-4">
        <ul>
          <h4>Strategy & business intelligence</h4>
          <li>Omni-experience planning</li>
          <li>Brand strategy</li>
          <li>Commerce intelligence & strategy</li>
          <li>Retail strategy</li>
          <li>Integrated commerce</li>
          <li>Omnichannel, shopper marketing & e-commerce</li>
          <li>Assisted selling & associate training</li>
          <li>Consumer promotions, demos & sampling (DTC)</li>
          <li>Merchandising</li>
        </ul>
      </div>
      <div className="column text is-4">
        <ul>
          <h4>Performance media</h4>
          <li>Content channel planning & programmatic</li>
          <li>Social media & influencer marketing</li>
          <li>Retail media & digital shopper</li>
        </ul>
        <ul>
          <h4>Brand design & content</h4>
          <li>Brand development</li>
          <li>Package design</li>
          <li>Digital design</li>
          <li>Environmental design</li>
        </ul>
      </div>
      <div className="column text is-4">
        <ul>
          <h4>Experiential marketing</h4>
          <li>Live, virtual & hybrid immersive events</li>
          <li>B2B events + conferences</li>
          <li>Sponsorship activation</li>
        </ul>
        <ul>
          <h4>Measurement & analytics</h4>
          <li>Integrated analytics</li>
          <li>Location & geographic analytics</li>
          <li>Return on investment</li>
        </ul>
      </div>
    </div>
  )
}

export default PreFooter
